import { Icon } from '../icons/Icon.jsx';

/* 세그먼트 컨트롤 */
export const Seg = ({ value, onChange, options }) => (
  <div className="seg">
    {options.map(o => (
      <button key={o.value} type="button" className={"seg__opt" + (value === o.value ? " is-on" : "")} onClick={() => onChange(o.value)}>
        {o.icon && <Icon name={o.icon} size={15} />}{o.label}
      </button>
    ))}
  </div>
);

export default Seg;
